module.exports = __webpack_public_path__ + "static/img/miniImg3.66282b1a.png";